import type { UtilityContext } from '@change-corgi/core-react/utilityContext';

import {
	SAPClaimSocialStarterPetitionAngles,
	type SapClaimSocialStarterPetitionAnglesMutation,
	type SapClaimSocialStarterPetitionAnglesMutationVariables,
} from './claimSocialStarterPetitionAngles.graphql';

type Params = SapClaimSocialStarterPetitionAnglesMutationVariables['input'] & { utilityContext: UtilityContext };

// Best-effort link to the already-created petition; failures are only logged, never surfaced or blocking.
export async function claimSocialStarterPetitionAngles({ token, petitionId, utilityContext }: Params): Promise<void> {
	const {
		errorReporter,
		gql: { fetch },
	} = utilityContext;

	let requestId: string | undefined;
	let reason: string | undefined;

	try {
		const {
			data,
			errors,
			requestId: fetchRequestId,
		} = await fetch<SapClaimSocialStarterPetitionAnglesMutation, SapClaimSocialStarterPetitionAnglesMutationVariables>({
			query: SAPClaimSocialStarterPetitionAngles,
			variables: { input: { token, petitionId } },
			rejectOnError: false,
		});
		requestId = fetchRequestId;

		if (errors?.length) throw new Error(errors.map((error) => error.message).join('; '));
		if (!data) throw new Error('No data returned from mutation.');

		const { success, reason: failureReason } = data.claimSocialStarterPetitionAngles;
		if (!success) {
			reason = failureReason ?? undefined;
			throw new Error('Failed to claim social starter petition angle');
		}
	} catch (error) {
		void errorReporter.report({
			error: error instanceof Error ? error : new Error('Failed to claim social starter petition angle'),
			context: { requestId, reason },
		});
	}
}
